import React from 'react';
import {Select, FormControl, InputLabel, MenuItem, ListSubheader } from '@mui/material';
import { apiSlice, useChangeUserHospitalMutation, useGetHospitalsQuery } from '../api/apiSlice';
import { UserContext } from './Hooks/useUser';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/system';
import { useContext } from 'react';

function HospitalDropdown(){
    const { user, setUser } = useContext(UserContext);
    const dispatch = useDispatch();
    const [updateUserHospital] = useChangeUserHospitalMutation();
    
    const { data: hospitals = [] } = useGetHospitalsQuery();

    // Group hospitals by organization
    const hospitalsByOrg = hospitals.reduce((acc, hospital) => {
        const orgId = hospital.organization?.id || 'unknown';
        if (!acc[orgId]) {
            acc[orgId] = {
                organization: hospital.organization,
                hospitals: []
            };
        }
        acc[orgId].hospitals.push(hospital);
        return acc;
    }, {});

    // Sort organizations and hospitals within each organization
    const sortedOrganizations = Object.keys(hospitalsByOrg)
        .sort((a, b) => {
            const nameA = hospitalsByOrg[a].organization?.name || 'Unknown Organization';
            const nameB = hospitalsByOrg[b].organization?.name || 'Unknown Organization';
            return nameA.localeCompare(nameB);
        })
        .map(orgId => ({
            id: orgId,
            name: hospitalsByOrg[orgId].organization?.name || 'Unknown Organization',
            ...hospitalsByOrg[orgId],
            hospitals: hospitalsByOrg[orgId].hospitals.sort((a, b) => a.name.localeCompare(b.name))
        }));

    const hospitalsByOrganization = organization => {
        const hospitals = organization.hospitals.map(hospital => (
            <MenuItem sx={{ pl: 3, fontSize: 14 }} key={hospital.id} value={hospital.id}>
                {hospital.name}
            </MenuItem>
        ));
        return [<ListSubheader sx={{fontSize: 14 }} key={organization.id}>{organization.name}</ListSubheader>, hospitals];
    };

    const handleChangeDropdown = async(selectedHospitalId) => {
        await updateUserHospital({
            user: user,
            hospital_id: selectedHospitalId
        }).unwrap().then((payload) => {
            setUser({
                ...user,
                hospital: payload.hospital
            });
        });
        dispatch(apiSlice.util.invalidateTags(['Card', 'ProposedMatch']));
    };

    return ( 
        <Box p={2}>
            <FormControl sx={{ width: '100%', height: '100%'}}>
                <InputLabel>Select A Hospital</InputLabel>
                <Select
                    value={user.hospital?.id}
                    label="Select A Hospital"
                    onChange={(e) => handleChangeDropdown(e.target.value)}
                    fullWidth
                >
                    {sortedOrganizations.map(organization => hospitalsByOrganization(organization))}
    
                </Select>
            </FormControl>    
        </Box>
        
    );
}

export default HospitalDropdown;